import { render, staticRenderFns } from "./PaymentAnonymous.vue?vue&type=template&id=35d254f0&"
import script from "./PaymentAnonymous.vue?vue&type=script&lang=js&"
export * from "./PaymentAnonymous.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports